import {Component, Prop, Mixins} from 'vue-property-decorator';
import LoadingMixin from "@/mixins/LoadingMixin";
import ShoppingCartMixin from '@/mixins/ShoppingCartMixin';
import ProductMixin from '@/mixins/ProductMixin';
import ColorMixin from '@/mixins/ColorMixin';
import ProductOptionsModal from './ProductOptionsModal.vue'

@Component({
    components: {
        ProductOptionsModal
    }
})
export default class MiniCart extends Mixins(LoadingMixin, ShoppingCartMixin, ProductMixin, ColorMixin) {
    @Prop({type: Boolean, required: false, default: false})
    private isMobile!: boolean;

    cartHeight = '655px';
    stickyTop = 140;
    //Products and services (pns) container height. Use for sticky scroll
    pnsContainerHeight = 0;

    private showProductOptionsRequiredModal = false;

    get phoneErrorMessage(): string {
        if (this.phoneOptionError && this.phoneOptionError.message) {
            return this.phoneOptionError.message;
        }
        return '';
    }

    get errorMessage(): string {
        if (this.batteryBkError && this.batteryBkError.message) {
            return this.batteryBkError.message;
        }
        return '';
    }

    get directoryErrorMessage(): string {
        if (this.directoryNameError && this.directoryNameError.message) {
            return this.directoryNameError.message;
        }
        return '';
    }

    get invalidEmailAddressesErrorMessage(): string {
        if (this.invalidEmailAddressesError && this.invalidEmailAddressesError.message) {
            return this.invalidEmailAddressesError.message;
        }
        return '';
    }

    get invalidCloudBackupEmailErrorMessage(): string {
        if (this.invalidCloudBackupEmailError && this.invalidCloudBackupEmailError.message) {
            return this.invalidCloudBackupEmailError.message;
        }
        return '';
    }

    get invalidTopBoxLeaseOptionErrorMessage(): string {
        if(this.topBoxLeaseError && this.topBoxLeaseError.message){
            return this.topBoxLeaseError.message;
        }
        return '';
    }

    get invalidAvastEmailErrorMessage(): string {
        if (this.hasInvalidAvastEmailError && this.hasInvalidAvastEmailError.message) {
            return this.hasInvalidAvastEmailError.message;
        }
        return '';
    }

    get invalidVoicemailPlusEmailErrorMessage(): string {
        if (this.hasInvalidVoicemailPlusEmailError && this.hasInvalidVoicemailPlusEmailError.message) {
            return this.hasInvalidVoicemailPlusEmailError.message;
        }
        return '';
    }

    get invalidStaticIpOptionErrorMessage(): string {
        if (this.invalidStaticIpOptionError && this.invalidStaticIpOptionError.message) {
            return this.invalidStaticIpOptionError.message;
        }
        return '';
    }

    get invalidStreamingDevicesErrorMessage(): string {
        if (this.invalidStreamingDevicesError && this.invalidStreamingDevicesError.message) {
            return this.invalidStreamingDevicesError.message;
        }
        return '';
    }

    get cartContainerHeight() {
        if (this.isMobile) {
            return {};
        }
        return {minHeight: `${this.pnsContainerHeight}px`};
    }

    get cartStype() {
        if (this.isMobile) {
            return {};
        }
        return {top: `${this.stickyTop}px`, height: this.cartHeight};
    }

    get detailsLabel(): string {
        return this.isEmployee ? 'Update and Return' : 'Complete Order'
    }

    mounted () {
        this.$nextTick(function() {
            // use to calculate menu and alerts height
            window.addEventListener('scroll', this.calcContainerHeight);

            //Init
            this.calcContainerHeight();
        });
    }

    getPnsContainer() {
        let i = 0;
        const max = 10; // how far deep to look for pnsContainer element
        let node = this;
        let pnsContainer = node.$refs && node.$refs.pnsContainer;
        let parentNode = node.$parent;
        while (i < max && !pnsContainer) {
            pnsContainer = parentNode.$refs && parentNode.$refs.pnsContainer;
            if (parentNode && parentNode.$parent) {
                parentNode = parentNode.$parent;
            }
            i++;
        }

        return pnsContainer;
    }

    calcContainerHeight() {
        if (this.isMobile) {
            return;
        }
        const $el = this.getPnsContainer() as HTMLDivElement;
        if (!$el) { return;}

        const pageMenuWithoutCategory = document.querySelector('aside.hide-category.is-page') as HTMLDivElement;
        const pageMenu = document.querySelector('aside.menu.is-page') as HTMLDivElement;
        const mainCategory = document.querySelector('#main-nav-menu__category') as HTMLDivElement;
        let stickyTop = 150;
        if (pageMenuWithoutCategory) {
            const pageMenuWithoutCategoryOffsetHeight = pageMenuWithoutCategory.offsetHeight;
            stickyTop = pageMenuWithoutCategory.offsetTop + pageMenuWithoutCategoryOffsetHeight;
        } else if (pageMenu) {
            const mainCategoryOffsetHeight = mainCategory ? mainCategory.offsetHeight : 0;
            const pageMenuOffsetHeight = pageMenu.offsetHeight;
            stickyTop = pageMenu.offsetTop + mainCategoryOffsetHeight + pageMenuOffsetHeight;
        }
        this.stickyTop = stickyTop;
        this.pnsContainerHeight = $el.offsetHeight;
    }

     validation(e: any) {
        if (this.errorMessage || this.phoneErrorMessage || this.directoryErrorMessage
            || this.invalidEmailAddressesErrorMessage || this.invalidCloudBackupEmailErrorMessage || this.invalidTopBoxLeaseOptionErrorMessage
            || this.invalidAvastEmailErrorMessage || this.invalidVoicemailPlusEmailErrorMessage || this.invalidStaticIpOptionErrorMessage
            || this.invalidStreamingDevicesErrorMessage) {
            this.shouldTriggerValidation(true);
            const { name, params: { serviceTypeId }} = this.$router.currentRoute;
            const errorForService = this.errors.find(err => err && err.serviceTypeId);
            if (errorForService && (errorForService.serviceTypeId !== serviceTypeId  || name !== 'services')) {
                 this.showProductOptionsRequiredModal = true;
            }

        } else {
            this.shouldTriggerValidation(false);
            if (this.isEmployee) {
                this.returnToEmployeePortal();
            } else {
                this.$router.push({path: '/new-customer'});
            }
        }
        return false;
    }

    storeServiceTypeIdWithError(value: string) {
        this.showProductOptionsRequiredModal = false;
        this.$emit('product-modal-close', value);
    }

    beforeDestroy() {
        window.removeEventListener('scroll', this.calcContainerHeight);
    }
}
